import React, { Fragment, useState, useEffect } from "react";
import { Button, Modal, Badge } from "react-bootstrap";
//** Import Image */
import PageTitle from "../container/layouts/PageTitle";
import axios from "axios";
import { Progress } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import profile05 from "../images/profile/noimg.png";
import { getInstance } from '../config/token';
import Spinner from 'react-bootstrap/Spinner'
import $ from 'jquery';
import linkifyHtml from 'linkifyjs/html'
import dateFormat from "dateformat";
import { useHistory, Link } from "react-router-dom";
import AddContactPopup from "../contact/addContactPopup";
import SmsReplyPopup from "./smsReplyPopup";
import InfiniteScroll from "react-infinite-scroll-component";
const SmsDetail = (props) => {
  const history = useHistory()
  const [activeToggle, setActiveToggle] = useState("posts");
  const [sendMessage, setSendMessage] = useState(false);
  const [postModal, setPostModal] = useState(false);
  const [cameraModal, setCameraModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [smsDetail, setSmsDetail] = useState([]);
  // const [message, setmessage] = useState("");
  // const [file, setFile] = useState("");
  // const [loaded, setLoader] = useState(0);
  // const [fileName, setFileName] = useState([]);
  // const [fileLabel, setFileLabel] = useState("");
  // const [filePath, setFilePath] = useState([]);
  const[modalStatus, setModalStatus] = useState(false)
  const[statusSmsId, setStatusSmsId] = useState("")
  const[statusSmsType, setStatusSmsType] = useState("")
  const [loadingStatus, setLoadingStatus] = useState(false);
  const[status, setStatus] = useState("")
  // const[messageLoading, setMessageLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const[showContactPopup, setShowContactPopup] = useState(false)
  const[contactId, setContactId] = useState(null)
  const[profilePic, setProfilePic] = useState('')
  const[userType, setUserType] = useState(0)

  const [replay, setReplay] = useState(false);
  const [toPhoneNo, setToPhoneNo] = useState("")
  const [fullName, setFullName] = useState("")
  const [smsList, setSmsList] = useState([])
  const [hasMoreSms, setHasmoreSms] = useState(true)
  const[currentPage, setCurrentPage] = useState(1)
  const[pageSize, setPageSize] = useState(20)
  const[scroll, setScroll]=useState("initial")
  const[searchKey, setSearchKey] = useState('')
  // const prefix = process.env.REACT_APP_API_URL;
  

  useEffect(() => {
    window.scrollTo(0, 0);
    // window.scrollTo(0, document.body.scrollHeight);
    setLoading(true);
  }, []);

  useEffect(() => {
    getSmsDetails();
  }, [currentPage, searchKey]);

  $('body').on('click', 'a', function(e) {
    e.target.target = '_blank';
  });

  const goToPage = (page) =>{
    if(page == 'sms'){
       history.push("/sms-list");
    }
    if(page == 'ticket'){
       history.push("/ticket-list");
    }
    setShowPopup(false)
 }

 const fetchMoreData = () => {
  setScroll("infinite")
  //  getSmsDetails(currentPage + 1)
   setCurrentPage(currentPage + 1)
 }

 const onSearchChange = (e) => {
  setScroll("search")
  setSearchKey(e.target.value)
  // setPageSize(defaultPageSize)
  setCurrentPage(1)
  // setSelected([])
  // setHasmoreSms(true)
  // getSmsDetails(1, "search");
}

  const getSmsDetails = () => {
    let path = window.location.pathname.split("/");
    let smsId = path[path.length - 1].split("-");

    let reqObj = {
      search : searchKey,
      page : currentPage,
      size : pageSize,
      id : smsId[0]
    }

    // setLoading(true);
    let config = getInstance('POST', `/api/get_sms_detail/`, reqObj);
    axios(config).then((res) => {
      if(scroll == 'initial'){
        let phoneNo = res.data[0] && res.data[0].phoneNoTwo && res.data[0].phoneNoTwo.phone ? res.data[0].phoneNoTwo.phone : ''
        let user_type = res.data[0] && res.data[0].phoneNoTwo && res.data[0].phoneNoTwo.type
        let name = res.data[0] && res.data[0].phoneNoTwo ? res.data[0].phoneNoTwo.first_name && res.data[0].phoneNoTwo.last_name ? res.data[0].phoneNoTwo.first_name + " " + res.data[0].phoneNoTwo.last_name : res.data[0].phoneNoTwo.first_name ? res.data[0].phoneNoTwo.first_name : res.data[0].phoneNoTwo.last_name ? res.data[0].phoneNoTwo.last_name : '' : ''
        let id = res.data[0] && res.data[0].phoneNoTwo && res.data[0] && res.data[0].phoneNoTwo.id ? res.data[0] && res.data[0].phoneNoTwo.id : null
        let profile_pic = res.data[0] && res.data[0].phoneNoTwo && res.data[0].phoneNoTwo.profile ? res.data[0].phoneNoTwo.profile : profile05
        let smsDetailData = res.data[0] && res.data[0].user_support_sms_messages ? res.data[0].user_support_sms_messages : []
        setContactId(id)
        setFullName(name)
        setToPhoneNo(phoneNo)
        setSmsDetail(res.data);
        setProfilePic(profile_pic)
        setSmsList(smsDetailData)
        setUserType(user_type)
      }
      
      let smsListData = res.data[0] && res.data[0].user_support_sms_messages ? res.data[0].user_support_sms_messages : []
      if(smsListData.length > 0){
        if(scroll == 'infinite'){
          setSmsList(smsList.concat(smsListData))
        } else {
          setSmsList(smsListData)
        }
        setHasmoreSms(true)
      } else {
        if(scroll == 'search'){
          setSmsList([])
        }
        setHasmoreSms(false)
      }
      setLoading(false);
    });
  };

  const showReplayModal = (type) => {
    setReplay(type);
    // setFileName([])
  };

  const contactPopup = () => {
    setShowContactPopup(true)
  }
  
  const closeContactPopup = () => {
    setShowContactPopup(false)
  }

  const reloadSmsDetail = () => {
    getSmsDetails()
  }

  const options = {
    settings: {
      overlayColor: "#000000",
    },
  };
  // const handleEditorChange = (content, editor) => {
  //   setmessage(content)
  // };

  const openStatusModal = (ticketId, statusType) => {
    if(localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2){
      setModalStatus(true)
      setStatusSmsId(ticketId)
      setStatusSmsType(statusType)
    }
  }

  const onStatusChange = (e, smsIds) => {
    setStatus(e.target.value)
  }

  const changeStatus = (type, smsIds) => {
    setLoadingStatus(true)
    let requestObj = {
      status: type,
      threadIds: smsIds,
    };
    let config = getInstance('POST', `/api/update_sms_status`, requestObj);
    axios(config)
      // .post(prefix + "/api/create_ticket", requestObj)
      .then((res) => {
        setLoadingStatus(false)
        toast.success("Ticket status changed", {
          position: "top-right",
        });
        setStatusSmsId("")
        setStatusSmsType("")
        setModalStatus(false)
        props.history.push("/sms-list");
      })
      .catch((err) => {
        let message = "Something went wrong!"
        setLoadingStatus(false)
        if(err.response && err.response.data && err.response.data.message){
          message = err.response.data.message
        }
        toast.error(message, {
          position: "top-right",
        });
        console.log(err)
      });
  }

  return (
    <Fragment>
      {/* <PageTitle activeMenu="Profile" motherMenu="App" /> */}
      {/* <h4>Ticket title will be this.</h4> */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {
          showContactPopup ? 
          <AddContactPopup contactId = {contactId} closeContactPopup = {closeContactPopup} type="sms-detail" userType = {userType} reloadSmsDetail={reloadSmsDetail} contactPopupShow = {showContactPopup} />
          :""
        }
        {
          replay ? 
          <SmsReplyPopup toPhoneNo = {toPhoneNo} showReplayModal = {showReplayModal} type="sms-detail" reloadSmsDetail={reloadSmsDetail} replayPopupShow = {replay} />
          :""
        }
      <Modal
          show={modalStatus}
          // onHide={() => this.setState({ cameraModal: false })}
          className="modal fade"
          id="statusModal"
        >
        <div className="">
            <div className="modal-header">
              <h5 className="modal-title">Update Status - {process.env.REACT_APP_SMS_PREFIX + statusSmsId}</h5>
              <Button
                variant=""
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => setModalStatus(false)}
              >
                <span>×</span>
              </Button>
            </div>
            <div className="modal-body">
              <form
                className="comment-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  // setNewEvent(false);
                }}
              >
                <div>
                  <div className="form-group">
                    <div className="form-group">
                      <label className="text-black font-w500">
                        Select Type
                      </label>
                      <select
                        className="form-control form-border-color"
                        // style={{ width: "fit-content" }}
                        name="type"
                        id="type"
                        defaultValue={statusSmsType}
                        onChange={(e) => onStatusChange(e)}
                      >
                        <option value="0">Pending</option>
                        <option value="1">Completed</option>
                        
                      </select>
                    </div>
                  </div>
                  <div className="form-group" style={{ textAlign: "center" }}>
                    <input
                      disabled={loadingStatus}
                      type="submit"
                      value="Update Status"
                      className="btn btn-primary"
                      onClick={() => changeStatus(status, [statusSmsId])}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal>
        <Modal className="modal fade" show={showPopup}>
            <div className="">
              <div className="modal-header" style={{backgroundColor : "#FE634E"}}>
                <h5 className="modal-title">Go To:</h5>
                <Button
                  variant=""
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  onClick={() => setShowPopup(false)}
                >
                  <span>×</span>
                </Button>
              </div>
              <div className="modal-body" style={{textAlign : "center"}}>
                <form
                  className="comment-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    // this.setState({ newEvent: false });
                  }}
                >
                  <div>
                    <div className="form-group">
                      <div className="form-group">

                      <div onClick={() => goToPage("sms")}>
                        <strong style={{cursor : "pointer", color : "black"}}>BG SMS</strong>
                        <br/>
                        <br/>
                     </div>
                     <div onClick={() => goToPage("ticket")}>
                        <strong style={{cursor : "pointer", color : "black"}}>BG Help Desk</strong>
                        <br/>
                        <br/>
                     </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              {loading ? (
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                    position: "absolute",
                    marginBottom: "10px",
                  }}
                >
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden"></span>
                  </Spinner>{" "}
                </div>
              ) : (
                <div>
                  <div className="post-details">
                    <div className="row">
                      <div className="col-xl-10 text-center">
                      <ul className="mb-4 post-meta d-flex flex-wrap text-black">
                          <li className="post-author mr-3">
                        {smsDetail[0] &&
                          smsDetail[0].id
                            ? <React.Fragment> 
                            <span style={{cursor : "pointer"}} onClick={() => setShowPopup(true)}>Home - </span> 
                            <Link style={{cursor : "pointer", color: "black"}} to={"/sms-list"}>
                            SMS -
                          </Link> 
                          <span>{" " + process.env.REACT_APP_SMS_PREFIX + smsDetail[0].id}</span>
                          </React.Fragment>
                            : ""}
                        </li></ul>
                        <h3 className="mb-2 text-black ticket-title-custom">
                          {fullName ? <span style={{display : "block"}}>{fullName}</span> : ""}
                          <span style={{display : "block"}}>{toPhoneNo}</span>
                        </h3>

                        <ul className="mb-4 post-meta d-flex flex-wrap">
                          <li className="post-author mr-3"> {smsDetail &&
                          smsDetail[0] &&
                          smsDetail[0].id
                            ? <strong style={{color : "black"}}>{process.env.REACT_APP_SMS_PREFIX + smsDetail[0].id}</strong>
                            : ""}</li>
                          <li className="post-date mr-3">
                            <i className="fa fa-calender" />
                            {smsDetail &&
                            smsDetail[0] &&
                            smsDetail[0].createdAt
                              ? new Date(
                                  smsDetail[0].createdAt
                                ).toLocaleString('en-US', { timeZone: 'America/New_York' })
                              // dateFormat(new Date(smsDetail[0].createdAt), "m/d/yyyy, h:M:s TT")
                              : ""}
                          </li>

                          {/* <li className="post-comment"style={{marginRight : smsDetail && smsDetail[0] && smsDetail[0].order_id ? "1rem" : ""}}>
                            {smsDetail &&
                            smsDetail[0] &&
                            smsDetail[0].order_id
                              ? "BGUSA" + smsDetail[0].order_id
                              : ""}
                          </li> */}
                          {/* <li className="post-comment"style={{marginRight : "0.3rem", fontWeight : "600"}}>
                            {smsDetail &&
                            smsDetail[0] &&
                            smsDetail[0].source &&
                            smsDetail[0].source == "email"
                              ? smsDetail[0].user_type == 3 ? "rent@babiesgetaway.com" : smsDetail[0].user_type == 4 ? "support@babiesgetaway.com" : ""
                              : ""}
                          </li> */}
                        </ul>
                          <input
                            type="text"
                            name="title"
                            style={{
                              // marginLeft: "5px",
                              // width: "fit-content",
                              // display: "inline",
                              marginBottom: "1rem",
                            }}
                            className="form-control form-border-color"
                            maxLength={255}
                            placeholder="Search Here..."
                            value={searchKey}
                            onChange={(e) => onSearchChange(e)}
                          />
                      </div>
                      <div className="col-xl-2">
                      <div style={{marginBottom : "0.5rem"}}>
                          {smsDetail && smsDetail[0] && smsDetail[0].id ? 
                        <Badge variant="success light" style = {{cursor : "pointer"}} className={smsDetail[0].status == 0 ?"status-pending" : "status-closed"}>
                          {smsDetail[0].status == 0
                            ? 
                            <span onClick={() => openStatusModal(smsDetail[0].id, 0)}>
                                Pending
                              </span>
                            : smsDetail[0].status == 1? 
                            <span onClick={() => openStatusModal(smsDetail[0].id, 1)}>
                              Completed
                            </span>
                             :""
                          }
                        </Badge> : ""}
                        </div>
                        <div style={{marginBottom : "0.5rem"}}>
                        <button
                          className="btn btn-secondary"
                          onClick={() => showReplayModal(true)}
                        >
                          <span className="mr-2">
                            <i className="fa fa-reply" />
                          </span>
                          Reply
                        </button>
                        </div>
                        {fullName ? "" :
                        <button
                        // style={{marginLeft : "10px"}}
                        className="btn btn-secondary"
                        onClick={() => contactPopup()}
                      >
                        {/* <span className="mr-2">
                          <i className="fa fa-reply" />
                        </span> */}
                       {userType == 3 ? "+ Customer" : "+ Contact"}
                      </button>}
                      </div>
                    </div>
                  </div>

                  <div className="profile-tab">
                    <div className="custom-tab-1">
                      <div className="tab-content">
                        <div
                          id="my-posts"
                          className={`tab-pane fade ${
                            activeToggle === "posts" ? "active show" : ""
                          }`}
                        >
                          <InfiniteScroll
                              dataLength={smsList.length}
                              next={fetchMoreData}
                              hasMore={hasMoreSms}
                              loader={<h4>Loading...</h4>}
                            >
                          <div className="my-post-content pt-3">
                            {smsList.map(
                                function (item, i) {
                                  return (
                                    <div className="profile-uoloaded-post border-bottom-1 pb-5">
                                      <div className="media pt-3 pb-3">
                                        <img
                                          src={
                                            item.user &&
                                            item.user.profile_picture
                                              ? process.env
                                                  .REACT_APP_IMAGE_URL +
                                                item.user.profile_picture
                                              : profilePic
                                          }
                                          alt=""
                                          className="mr-3 rounded"
                                          width={75}
                                        />
                                        <div className="media-body" style={{overflow : "auto", marginTop : localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? "" : "15px"}}>
                                          <h5 className="m-b-5"  style={{color: "orange"}}>
                                            {item.user
                                              ? item.user.first_name &&
                                                item.user.last_name
                                                ? item.user.first_name +
                                                  " " +
                                                  item.user.last_name
                                                : item.user.first_name
                                                ? item.user.first_name
                                                : item.user.last_name
                                                ? item.user.last_name
                                                : "Admin/Employee"
                                              : fullName ? fullName : 'Participant'
                                              }
                                              
                                          </h5>
                                          {/* <h5>{localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? 
                                                item.user && item.user.email ? "" + item.user.email : ""
                                                : ""
                                              }</h5> */}
                                               {/* <h5 className="m-b-5">
                                               {item.user_support_sms_phone && item.user_support_sms_phone.phone ? item.user_support_sms_phone.phone : "-"}
                                               </h5> */}
                                            <h5>{
                                              new Date(
                                                item.createdAt
                                              ).toLocaleString('en-US', { timeZone: 'America/New_York' })
                                              // dateFormat(new Date(item.createdAt), "m/d/yyyy, h:M:s TT")
                                            
                                          }</h5>
                                          
                                          <h5>{(localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2) && item.sms_status ?
                                          <Badge variant="success light" className={"status-open"} 
                                          // style={{backgroundColor : item.sms_status == "" ? : }}
                                          >
                                            <span>
                                            {item.sms_status.charAt(0).toUpperCase() + item.sms_status.slice(1)}
                                            </span>
                                            </Badge>
                                              :""
                                          }</h5>
                                          {smsList.length - 1 == i ?  
                                            <button
                                              className="btn btn-secondary"
                                              onClick={() => showReplayModal(true)}
                                            >
                                              <span className="mr-2">
                                                <i className="fa fa-reply" />
                                              </span>
                                              Reply
                                            </button> : ""}
                                        </div>
                                        
                                      </div>
                                      <div style={{overflow : "auto", fontWeight : '700'}} dangerouslySetInnerHTML={{ __html: linkifyHtml(item.message) }} />
                                      {/* <div style={{overflow : "auto", fontWeight : '700'}}> {item.message} </div> */}
                                      <div style={{display : "inline-block", marginTop : "10px"}}>
                                      {item.user_support_sms_files &&
                                        item.user_support_sms_files.map(
                                          function (filePath, j) {
                                            return (
                                              <div style={{marginLeft : j == 0 ? "" : "5px", display : "inline-block"}}>
                                                <a
                                                  className="btn btn-secondary"
                                                  href={filePath.file}
                                                  target="_blank"
                                                  style={{backgroundColor : "#FE634E", borderColor : "#FE634E"}}
                                                >
                                                  {"Attachment " + (j+1)}
                                                </a>
                                                <br />
                                                <br />
                                              </div>
                                            );
                                          }
                                        )}
                                        </div>
                                      <br />
                                      <br />
                                    </div>
                                  );
                                }
                              )}
                          </div>
                          </InfiniteScroll>
                          <div className="up-arrow-div" onClick={()=>window.scrollTo(0, 0)}><i class="gg-arrow-up"></i></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default SmsDetail;
